import { strapiFetch } from '../../../entities/@api/Strapi';
import { BlogCategoriesResponse } from '../../../entities/@blog/BlogCategories/BlogCategories';
import { generateBlogCategoriesQuery } from '../../../entities/@blog/BlogCategories/BlogCategoriesRequests';
import { transformBlogCategoryToTab, transformToBlogCategory } from '../../../entities/@blog/BlogCategory/BlogCategoryTransformers';
import { isFetchResultSuccessful } from '../../../entities/FetchResult/FetchResult';
import { transformStrapiPaginationToPagination } from '../../../entities/Pagination/PaginationTransformers';
import { sortByOrder } from '../../../helpers/sort';
import trans from '../../../helpers/trans';
import { ReduxFetchAction } from '../../defaults';
import {
    setBlogCategories,
    setBlogCategoryTabs,
    setError,
    setHasFetched,
    setIsLoading,
    setIsSuccessful,
    setPagination,
} from './blogCategoriesSlice';

export const fetchBlogCategories: ReduxFetchAction = () => async dispatch => {
    dispatch(setIsLoading(true));
    dispatch(setHasFetched(false));
    dispatch(setIsSuccessful(false));
    dispatch(setError(''));
    dispatch(setBlogCategories([]));
    dispatch(setBlogCategoryTabs([]));

    try {
        const query = generateBlogCategoriesQuery();

        const blogCategoriesResponse = await strapiFetch<BlogCategoriesResponse>(`/blog-categories?${query}`);

        if (!isFetchResultSuccessful(blogCategoriesResponse)) {
            dispatch(setError(blogCategoriesResponse.error));
            return;
        }

        const { data, meta } = blogCategoriesResponse.data;

        const blogCategories = data?.length
            ? data.map(transformToBlogCategory)
            : [];

        const sortedBlogCategories = blogCategories.sort(sortByOrder);

        const allNews = trans('entities.blogCategory.all.value');
        const blogCategoryStrings = sortedBlogCategories.map(category => category.slug);
        const blogCategoryTabs = sortedBlogCategories.map(transformBlogCategoryToTab);

        const pagination = meta
            ? transformStrapiPaginationToPagination(meta.pagination)
            : undefined;

        dispatch(setBlogCategories([allNews, ...blogCategoryStrings]));
        dispatch(setBlogCategoryTabs(blogCategoryTabs));
        dispatch(setPagination(pagination));

        dispatch(setIsSuccessful(true));
    } catch (error) {
        console.error('[fetchBlogCategories]', error);
    } finally {
        dispatch(setIsLoading(false));
        dispatch(setHasFetched(true));
    }
};
